import { el, clear } from "./dom.js";
import { MAG, magButton, magCover } from "./magazine/kit.js";
import { listAllMedia } from "../db/media.js";
import { statusLabel } from "./status-badge.js";
import { navigate } from "../main.js";
import { backlogAgeDays } from "../utils/insights.js";

// "Can't decide?" (roadmap #20): pick something at random from a category's
// backlog — on your radar, planning to start, or paused — with Another / Open.

const BACKLOG = new Set(["want_to_check", "haven_started", "on_pause"]);

export function randomPickButton(mediaType) {
	return el("button.app-header__icon", {
		type: "button",
		title: "Pick something at random",
		"aria-label": "Pick something at random",
		onclick: () => openRandomPick(mediaType),
	}, "🎲");
}

export async function openRandomPick(mediaType) {
	const pool = (await listAllMedia()).filter((m) => m.media_type === mediaType && BACKLOG.has(m.engagement_status));
	const body = el("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", padding: "6px 0" } });
	let last = null;
	const close = () => overlay.remove();

	function roll() {
		clear(body);
		if (pool.length === 0) {
			body.append(el("p", { style: { color: MAG.dim, textAlign: "center" } }, "Nothing waiting in this category — add something to your radar first."));
			return;
		}
		let pick = pool[Math.floor(Math.random() * pool.length)];
		if (pool.length > 1) while (pick === last) pick = pool[Math.floor(Math.random() * pool.length)];
		last = pick;
		const days = backlogAgeDays(pick);
		body.append(
			magCover(pick, { height: "180px", width: "128px", radius: "12px" }),
			el("div", { style: { fontFamily: "'Anton', sans-serif", fontSize: "22px", textTransform: "uppercase", textAlign: "center", color: "#fff", lineHeight: "1" } }, pick.title),
			el("div", { style: { fontFamily: "'Archivo', sans-serif", fontSize: "12px", color: MAG.dim, textAlign: "center" } },
				[statusLabel(pick.engagement_status, mediaType === "videogame" ? null : mediaType), days != null ? `waiting ${days} day${days === 1 ? "" : "s"}` : null].filter(Boolean).join(" · ")),
			el("div", { style: { display: "flex", gap: "8px", width: "100%" } },
				magButton("Another", { variant: "ghost", block: true, onClick: roll }),
				magButton("Open", { block: true, onClick: () => { close(); navigate(pick.route); } })),
		);
	}

	const overlay = el(
		"div.modal-overlay",
		{ onclick: (e) => e.target === overlay && close() },
		el("div.modal", {}, el("h2.modal__title", {}, "Can't decide?"), body,
			magButton("Close", { variant: "ghost", block: true, onClick: close, style: { marginTop: "8px", opacity: ".7" } })),
	);
	document.body.append(overlay);
	roll();
}
